/** Class names used by multiple components. */
const classNames = {
  stepNextButton: "stepNextButton",
  stepNextButtonMobile: "stepNextButtonMobile",
  stepNextButtonDesktop: "stepNextButtonDesktop"
};

export default classNames;
